module.exports = __webpack_public_path__ + "a4e83af67e5417a526e780d1532c41ea.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/Parrot/fonts/source-sans-pro/sourcesanspro-regular.svg
// module id = 26
// module chunks = 0 1 2 3 4 5 6 7 8 9